import { useEffect } from "react";
import useUserInfrastructure from "../infrastructure/hook/useUserInfrastructure";
import { Filter } from "../../../../domain/interfaces/PaginationBaseInterface";
import useRegistrationInfrastructure from "../../../registration/infrastructure/hook/useRegistrationInfrastructure";
import { Timestamp } from 'firebase/firestore';

export const useUsers = () => {
  const {
    userState,
    fetchUsersInfrastructure,
    setCurrentPageInfrastructure,
    setFilterInfrastructure,
    getUserTreeReferralsInfrastructure,
    applySearchInfrastructure,
    exportUsersInfrastructure
  } = useUserInfrastructure();

  const {
    registrationState
  } = useRegistrationInfrastructure();

  useEffect(() => {
    if (userState.users.length === 0) {
      fetchUsersInfrastructure();
    }
  }, []);

  const setCurrentPage = (page: number) => {
    setCurrentPageInfrastructure(page)
  }

  const fetchUsers = (page: number) => {
    setCurrentPage(page)
    fetchUsersInfrastructure(page)
  }

  const setFilter = (filter: Filter) => {
    setFilterInfrastructure(filter)
  }

  const handleNextPage = () => {
    if (userState.pagination.currentPage < userState.pagination.totalPages) fetchUsers(userState.pagination.currentPage + 1);
  };

  const handlePrevPage = () => {
    if (userState.pagination.currentPage > 1) fetchUsers(userState.pagination.currentPage - 1);
  };

  const getUserTreeReferrals = (userId: string | null) => {
    getUserTreeReferralsInfrastructure(userId)
  }

  const applySearch = () => {
    applySearchInfrastructure();
  }

  const exportUsers = async () => {
    const users = await exportUsersInfrastructure();
    if (users) {
      import('xlsx').then(XLSX => {
        const data = users.map(user => {
          const { _seconds: seconds, _nanoseconds: nanoseconds } = user.createdAt as unknown as { _seconds: number, _nanoseconds: number };
          const firestoreTimestamp = new Timestamp(seconds, nanoseconds);
          const jsDate = firestoreTimestamp.toDate();
          return {
            Nombre: user.name,
            Celular: user.phoneShow,
            Email: user.email,
            'Rango de Edad': user.ageRange,
            Genero: user.gender === "male" ? "Masculino" : "Femenino",
            Departamento: user.department.name,
            Ciudad: user.city.name,
            'Referido por': user.referrerId?.name || '',
            'Referidos Directos': user.referralCounts.direct,
            'Referidos Indirectos': user.referralCounts.indirect,
            'Tema de Interes': registrationState.topicsInterest.find(topic => topic.id === user.topicInterest)?.name || '',
            'Fecha de Registro': jsDate.toLocaleString(),
          };
        });

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Usuarios");
        XLSX.writeFile(workbook, "usuarios_filtrados.xlsx");
      });
    }
  };

  return {
    fetchUsers,
    setFilter,
    userState,
    handleNextPage,
    handlePrevPage,
    getUserTreeReferrals,
    applySearch,
    registrationState,
    exportUsers
  };
};
